import * as moment from 'moment';

import { PlanMetadata, User } from 'fitforce-document-sync';

import { Group } from 'app/group-management/models/group.model';
import { GroupTrainingLoad } from './group-training-load.model';
import { PftCftObservationDocument } from './individual-pft-cft-score.model';
import { IndividualTrainingLoad } from './individual-training-load.model';
import { PlanTrainingLoad } from './plan-training-load.model';
import { TabState } from './tab-state.model';
import { TrainingLoadAnalysis } from './training-load-analysis.model';
import { TrainingLoadParams } from './training-load-params.model';

export class ExploreStateModel {
  loading: boolean;
  marines: User[];
  groups: Group[];
  plans: PlanMetadata[];
  rangeStart: moment.Moment;
  rangeEnd: moment.Moment;
  weeks: { start: moment.Moment; end: moment.Moment; weekNumber: number }[];
  selectedMarine: User;
  selectedPlan: PlanMetadata;
  selectedGroup: Group;
  selectedGroupPlans: PlanMetadata[];
  tabState: TabState;

  individualTrainingLoads: IndividualTrainingLoad[];
  individualTrainingLoadAnalyses: TrainingLoadAnalysis[];
  planTrainingLoads: PlanTrainingLoad[];
  planTrainingLoadAnalyses: TrainingLoadAnalysis[];
  groupTrainingLoads: GroupTrainingLoad[];
  groupTrainingLoadAnalyses: TrainingLoadAnalysis[];
  trainingLoadParams: TrainingLoadParams[];
  loadingTrainingLoads: boolean;
  loadingAnalyses: boolean;

  individualPftScoreDocuments: PftCftObservationDocument[];
  individualCftScoreDocuments: PftCftObservationDocument[];
  groupPftScoreDocuments: PftCftObservationDocument[];
  groupCftScoreDocuments: PftCftObservationDocument[];
  loadingPftScores: boolean;
  loadingCftScores: boolean;
}
